// Educational popup for "Syndicate to Gitcha" - explains why agents would syndicate
import { useCallback, useEffect } from "react";

const SyndicateSplash = ({ show, onClose, onSyndicate }) => {
  useEffect(() => {
    if (!show) return;
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [show, onClose]);

  const handleBackdropClick = useCallback(
    (e) => {
      if (e.target === e.currentTarget) onClose?.();
    },
    [onClose]
  );

  if (!show) return null;

  return (
    <div className="mls-splash" onClick={handleBackdropClick}>
      <div className="mls-splash__card syndicate-splash">
        {/* Header icon area */}
        <div className="syndicate-splash__header">
          <div className="syndicate-splash__icon-circle">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <path d="M2 12h20" />
              <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
            </svg>
          </div>
        </div>

        <div className="mls-splash__content">
          <h3 className="mls-splash__address" style={{ textAlign: "center" }}>
            Syndicate to Gitcha
          </h3>
          <p className="mls-splash__message">
            Choose to display this want-listing on Gitcha to unlock sharing and enhanced marketing to your sphere and potential customers. You stay in control and can update your post or remove it at anytime.
          </p>

          <div className="mls-splash__cta">
            <div className="mls-splash__cta-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
            </div>
            <div>
              <h4>Why syndicate?</h4>
              <p>
                Unlike seller agents, buyer agents don't get signed calls from interested parties. Gitcha is the first platform where agents can display their buyers' wants and needs publicly - share with your sphere and leverage in your marketing efforts.
              </p>
            </div>
          </div>

          <div className="syndicate-splash__benefits">
            <div className="syndicate-splash__benefit">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#15803d" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 6 9 17l-5-5" />
              </svg>
              <span>Shareable link for social media and email campaigns</span>
            </div>
            <div className="syndicate-splash__benefit">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#15803d" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 6 9 17l-5-5" />
              </svg>
              <span>Visible to property owners and other agents on Gitcha</span>
            </div>
            <div className="syndicate-splash__benefit">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#15803d" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 6 9 17l-5-5" />
              </svg>
              <span>Update or remove anytime - you stay in control</span>
            </div>
          </div>

          <div className="mls-splash__actions">
            <button
              className="mls-splash__btn mls-splash__btn--primary"
              onClick={() => {
                onSyndicate?.();
                onClose?.();
              }}
            >
              Syndicate to Gitcha
            </button>
            <button className="mls-splash__btn mls-splash__btn--secondary" onClick={onClose}>
              Maybe Later
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SyndicateSplash;
